import * as R from "ramda";

export const SAVE_SELECTED_USER = "SAVE_SELECTED_USER";

export const saveSelectedProctoringUser = (payload) => {
  return { type: SAVE_SELECTED_USER, payload };
};

const initialState = {
  selectedUser: null,
};

const saveSelectedUser = (state, action) => {
  return R.assoc("selectedUser", action.payload, state);
};

export default function proctoringUsers(state = initialState, action) {
  switch (action.type) {
    case SAVE_SELECTED_USER: {
      return saveSelectedUser(state, action);
    }
    default:
      return state;
  }
}
